/**
 * 创建一个用于 Vue 的施密特触发器，会倾向于存储 truthy 值。
 * 如果被设置为 falsy 值，会在等待的时间之后，才生效。
 *
 * 使用方式：
 *
 * 1. 在 data() 里声明 xxxxxxxxStatus
 * 2. 在 computed 里声明 `status: makeSchmittTrigger('xxxxxxxxStatus', 300)`
 * 3. 直接使用 `this.status` 即可。如果要即时生效，仍然可修改 `this.xxxxxxxxStatus`
 *
 * @param {string} internalPropName
 * @param {number} time
 */
const makeSchmittTrigger = (internalPropName, time) => {
  const timerMarker = `___timer:${internalPropName}`;
  return {
    get() {
      return this[internalPropName];
    },
    set(val) {
      if (val) {
        if (this[internalPropName] !== val) this[internalPropName] = val;
        if (this[timerMarker]) clearTimeout(this[timerMarker]);
        this[timerMarker] = null;
        return;
      }
      if (!this[timerMarker]) {
        this[timerMarker] = setTimeout(() => {
          this[internalPropName] = val;
          this[timerMarker] = null;
        }, time);
      }
    }
  };
};
export default makeSchmittTrigger;
//# sourceMappingURL=makeSchmittTrigger.js.map
